import { useCallback } from 'react'

/**
 * Custom hook for displaying flash notifications
 * Abstracts the legacy App.events.publish pattern
 * @returns {Object} Notification methods
 */
const useNotifications = () => {
  const showSuccess = useCallback((message) => {
    if (typeof App !== 'undefined' && App.events) {
      App.events.publish('app:notification:flash:success', message)
    }
  }, [])

  const showError = useCallback((message) => {
    if (typeof App !== 'undefined' && App.events) {
      App.events.publish('app:notification:flash:error', message)
    }
  }, [])

  const showPluralizedSuccess = useCallback(
    (count, singularNoun, actionVerb) => {
      const pluralSuffix = count !== 1 ? 's' : ''
      showSuccess(`${count} ${singularNoun}${pluralSuffix} ${actionVerb}`)
    },
    [showSuccess],
  )

  return {
    showSuccess,
    showError,
    showPluralizedSuccess,
  }
}

export default useNotifications
